import React, { useState } from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import Img from "gatsby-image"
import Button from "@material-ui/core/Button"
import Hidden from "@material-ui/core/Hidden"
import Grid from "@material-ui/core/Grid"
import Box from "@material-ui/core/Box"
import styled from "styled-components"
import WrapTypo from "../components/WrapTypo"
import AnimeButton from "../components/AnimeButton"

const WhiteButton = styled(Button)`
  width: 207px;
  height: 45px;
  margin: auto;
  border: 1px solid #6e6e6e;
  text-align: center;
  border-radius: 0;
`

function SpUnfilterTime() {
  const data = useStaticQuery(graphql`
    query {
      sp_unfilter_time: file(relativePath: { eq: "up3_20211115.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      sp_unfiltertime_logo: file(relativePath: { eq: "Group153.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return (
    <>
      <Box bgcolor="#F4F4F4" width="100%" pb="30px">
        <Img fluid={data.sp_unfilter_time.childImageSharp.fluid} />
        <Box width="30%" m="10% auto 0" maxWidth="227px">
          <Img fluid={data.sp_unfiltertime_logo.childImageSharp.fluid} />
        </Box>
        <Box m="10% auto 0" width="60%" marginBottom="44px" textAlign="center">
          <WrapTypo fs="12px" lh="220%">
            新感覚のとろけるバスオイルで
          </WrapTypo>
          <WrapTypo fs="12px" lh="220%">
            艶と香りを纏う
            <br />
            あなただけのunfilter timeを
          </WrapTypo>
        </Box>
        <Box width="100%" m="10% auto 50px">
          <ButtonComponent />
        </Box>
      </Box>
    </>
  )
}

function ButtonComponent() {
  return (
    <>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <AnimeButton
          href="/product/"
          text="詳しく見る"
          width="clamp(150px,13vw,250px)"
          height="clamp(35px,2.5vw,50px)"
          fs="clamp(12px,1.2vw,24px)"
          color="#565656"
          border="solid 1px #565656"
          bgColor="#565656"
          afterColor="#565656"
        />
      </div>
    </>
  )
}
export default SpUnfilterTime
